import axios from "./axios";

export const postOffering = offering => axios.get().post(`/offering`, offering)
export const getOfferingTypes = () => axios.get().get(`/offering/types`)
